import getPanelDataItems from "./getPanelDataItems";

export default function getDefaultProps() {
  const panelData = getPanelDataItems();

  return panelData
    ? { runMode: "panel", ...panelData }
    : { runMode: "default" };
}
